import { oneSiam } from "./one-siam"
import { oneSiamLandingPage } from "./one-siam-landing-page"

export const extensionConfigs = {
  "one-siam": oneSiam,
  "one-siam-landing-page": oneSiamLandingPage,
}
